import React, { useContext, Fragment } from 'react';
import { Menu, Container, Button, Dropdown } from 'semantic-ui-react';
import { UserContext } from '../../app/layout/App';
import { NavLink, Link } from 'react-router-dom';

export const NavBar = () => {
  const { state, dispatch } = useContext(UserContext);
  const role = state.user?.type_utilisateur;

  return (
    <Menu inverted fixed='top'>
      <Container>
        <Menu.Item header as={NavLink} to='/' exact>
          Rai Disputa
        </Menu.Item>

        <Fragment>
          <Menu.Item name='About' as={NavLink} to='/about' exact />
          {!state.loggedIn && (
            <Menu.Item name='Contact' as={NavLink} to='/contact' exact />
          )}
          {state.loggedIn && (
            <>
              <Menu.Item name='Map' as={NavLink} to='/map' exact />
              <Menu.Item name='Cases' as={NavLink} to='/cases' exact />
              {(role === 'superadmin' || role === 'ksi') && (
                <Menu.Item>
                  <Button inverted as={Link} to='/case/new' content='Add a case' />
                </Menu.Item>
              )}
            </>
          )}
        </Fragment>

        {state.loggedIn ? (
          <Menu.Item position='right'>
            <Dropdown pointing='top left' text={`${state.user.email} (${role})`}>
              <Dropdown.Menu>
                {role === 'superadmin' && (
                  <>
                    <Dropdown.Item
                      as={Link}
                      to='/inscription'
                      text='Create a user'
                      icon='user plus'
                    />
                    <Dropdown.Item
                      as={Link}
                      to='/users'
                      text='Manage users'
                      icon='users'
                    />
                    <Dropdown.Item
                      as={Link}
                      to='/contacts'
                      text='Contacts list'
                      icon='mail'
                    />
                    <Dropdown.Item
                      as={Link}
                      to='/audit'
                      text='Audit log'
                      icon='history'
                    />
                  </>
                )}
                <Dropdown.Item
                  as={Link}
                  to='/account'
                  text='My account'
                  icon='user circle'
                />
                <Dropdown.Item
                  onClick={() => dispatch({ type: 'LOGOUT' })}
                  text='Sign out'
                  icon='power'
                />
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        ) : (
          <Menu.Item position='right'>
            <Button basic inverted content='Sign in' as={NavLink} to='/connexion' />
          </Menu.Item>
        )}
      </Container>
    </Menu>
  );
};

export default NavBar;
